"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedOptionsForAnswer = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const isValidAnswer_1 = require("./isValidAnswer");
const getSelectedOptionsForAnswer = (questionType, rule, a) => {
    var _a;
    if (!rule)
        return [];
    switch (questionType) {
        case FormQuestionType_1.default.CHECK: {
            const config = rule;
            if (a.value === 'yes' && config.yes) {
                return [config.yes];
            }
            if (a.value === 'no' && config.no) {
                return [config.no];
            }
            break;
        }
        case FormQuestionType_1.default.RATING: {
            if ((0, isValidAnswer_1.isValidAnswerWithType)(a, questionType, rule) && !a.notApplicable) {
                const choice = rule[a.value];
                return choice ? [choice] : [];
            }
            break;
        }
        case FormQuestionType_1.default.LIST: {
            const config = rule;
            if ((0, isValidAnswer_1.isValidAnswerWithType)(a, questionType, rule) && !a.notApplicable) {
                if (config.allowMultiSelect) {
                    const values = `${(_a = a.value) !== null && _a !== void 0 ? _a : ''}`.split(',');
                    return config.options.filter(z => values.some(v => `${z.value}` === `${v}`));
                }
                const choice = config.options.find(z => `${z.value}` === `${a.value}`);
                return choice ? [choice] : [];
            }
            break;
        }
        case FormQuestionType_1.default.NUMBER: {
            const config = rule;
            if ((0, isValidAnswer_1.isValidAnswerWithType)(a, questionType, rule) && !a.notApplicable) {
                const number = parseFloat(a.value);
                const isNumber = !isNaN(number);
                if (isNumber) {
                    if (config.lessThan.value !== null &&
                        number < parseFloat(`${config.lessThan.value}`)) {
                        return [config.lessThan];
                    }
                    if (config.moreThan.value !== null &&
                        number > parseFloat(`${config.moreThan.value}`)) {
                        return [config.moreThan];
                    }
                }
            }
            break;
        }
        case FormQuestionType_1.default.INFO:
        case FormQuestionType_1.default.TEXT:
        case FormQuestionType_1.default.DATETIME:
        case FormQuestionType_1.default.REPETITION:
        case FormQuestionType_1.default.PHOTO:
        case FormQuestionType_1.default.ISSUE:
        // -----------------
        // PAUSE DEPRECATION
        //case FormQuestionType.PAUSE:
        // -----------------
        case FormQuestionType_1.default.SIGNATURE:
        case FormQuestionType_1.default.SPT:
        case FormQuestionType_1.default.ASSET:
        case FormQuestionType_1.default.SECTION:
        case FormQuestionType_1.default.QUESTIONSET:
            return [];
    }
    return [];
};
exports.getSelectedOptionsForAnswer = getSelectedOptionsForAnswer;
exports.default = exports.getSelectedOptionsForAnswer;
